import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { useEffect } from "react";

export const viewResource = async (resourceId: string) => {
  const userId = await getUserId();
  await supabase.from("resource_views").insert({
    resource_id: resourceId,
    user_id: userId,
  });
};

export const useViewResource = (resourceId?: string) => {
  useEffect(() => {
    if (resourceId) {
      viewResource(resourceId);
    }
  }, [resourceId]);
};
